import { ValidationFunction } from './Validator.interface'

const MUST_BE_STRING_ERROR = 'Must be a string'
export const IsStringValidator =
  (error = MUST_BE_STRING_ERROR): ValidationFunction =>
  (value) => {
    if (!value) {
      return ''
    }
    if (typeof value !== 'string') {
      return error
    }
    return ''
  }
